import React, {useEffect, useState} from 'react';
import {Box,Flex} from "@chakra-ui/react";
import Cookies from 'js-cookie';
import {useHistory} from "react-router-dom";
import {reactLocalStorage} from "reactjs-localstorage";
const PageLayout = (props) => {

    const childStyle ={ maxW:'1500px', w:'100%', p:'20px' }

    return (
        <Flex justifyContent="center" flexDirection="row" alignItems='center'>
            {<props.pageComponent pageProps={childStyle} />}
        </Flex>
    );
}

export default PageLayout;
